export var createIsNativeOfflineAudioContext = function createIsNativeOfflineAudioContext(nativeOfflineAudioContextConstructor) {
  return function (anyContext) {
    if (nativeOfflineAudioContextConstructor === null) {
      throw new Error('The native OfflineAudioContext constructor is missing.');
    }

    return anyContext instanceof nativeOfflineAudioContextConstructor;
  };
};